import { Button, type ButtonProps } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { Link } from "react-router";

interface IBackProps extends ButtonProps {
  href?: string;
  label?: string;
  onClick?: () => void;
}

const Back: React.FC<IBackProps> = ({ href, label = "Retour", ...rest }) => {
  const baseProps = {
    classNames: {
      label: "text-primary-light-text",
    },
    variant: "transparent",
    leftSection: <IconArrowLeft />,
    ...rest,
  };

  if (href) {
    return (
      <Button {...baseProps} component={Link} to={href}>
        {label}
      </Button>
    );
  }

  return <Button {...baseProps}>{label}</Button>;
};

export default Back;
